import { WBButton, WBFlex } from '@admiin-com/ds-web';
import { t } from 'i18next';

export const SigningButton = ({
  onNext,
  loading,
  disableNext,
  onSkip,
  onBack,
  skipLabel,
}: {
  onNext?: () => void;
  loading?: boolean;
  disableNext?: boolean;
  onSkip?: () => Promise<void>;
  onBack?: () => void;
  skipLabel?: string;
}) => {
  return (
    <WBFlex
      gap={[1, 3]}
      justifyContent={['center', 'space-between']}
      mt={[0, 3]}
      flexDirection={['column', 'row']}
    >
      {onBack ? (
        <WBButton
          variant="outlined"
          sx={{ px: 3, flex: [1, 0], whiteSpace: 'nowrap' }}
          type="button"
          onClick={onBack}
        >
          {t('back', { ns: 'taskbox' })}
        </WBButton>
      ) : (
        <div />
      )}
      <WBFlex gap={3} justifyContent={'flex-end'} flexWrap="nowrap">
        {!!onSkip && (
          <WBButton
            variant="outlined"
            sx={{ px: [3, 0], flex: [1, 1], whiteSpace: 'nowrap' }}
            type="button"
            onClick={onSkip}
          >
            {skipLabel || t('skipSignature', { ns: 'taskbox' })}
          </WBButton>
        )}
        <WBButton
          variant="contained"
          sx={{ px: 3, flex: [1, 0], whiteSpace: 'nowrap' }}
          type="button"
          onClick={onNext}
          loading={loading}
          disabled={disableNext}
        >
          {t('next', { ns: 'taskbox' })}
        </WBButton>
      </WBFlex>
    </WBFlex>
  );
};
